import { QueryClient } from '@tanstack/react-query'
import { dataLayerPublish } from '@dhl/datalayer'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
      onError: (error) => {
        try {
          dataLayerPublish('ERROR', { id: 'react-query', error, message: error?.message, name: error?.name })
        } catch {
          //
        }
      },
    },
  },
})
